import { withNotificationContext } from '../../../main/components/notification'
import { Spinner } from '../../../main/components/spinner'
import { useAsyncModule } from '../../../main/services/async-modules-utils'
import { etfHoldingsAsyncModule } from './async-modules'

function LoadingFallback() {
  const widgetClass =
    'ml-3 mt-3 flex max-h-85 min-h-85 min-w-152 max-w-175 shrink grow basis-0  rounded-md border border-primary justify-center items-center'
  return (
    <div className="-ml-3 flex flex-wrap justify-center">
      {Array.from(Array(2)).map((_, index) => (
        <div key={index} className={widgetClass}>
          <Spinner />
        </div>
      ))}
    </div>
  )
}

function ETFHoldings() {
  const [etfHoldingsModule] = useAsyncModule({
    ...etfHoldingsAsyncModule,
    shouldLoadModule: true,
    errorSeverity: 'high',
  })
  const ETFHoldingsComponent = etfHoldingsModule?.ETFHoldings
  return ETFHoldingsComponent ? <ETFHoldingsComponent /> : <LoadingFallback />
}

export default withNotificationContext(ETFHoldings)
